import { routesBuilder } from '@guiker/api-definition'

import { MultipostListingInquiry, MultipostListingInquiryStats } from '../../../entity'
import { paths } from '../paths'
import { createMultipostInquiryPayloadSchema, multipostInquiryPerformanceStatsPayloadSchema } from './schemas'

const multipostInquiry = routesBuilder<MultipostListingInquiry>()({
  basePath: paths.multipostInquiry.all.base(),
})

export const routes = {
  getMultipostInquiryPerformanceStats: multipostInquiry.buildPost({
    path: '/performance-stats',
    payloadSchema: multipostInquiryPerformanceStatsPayloadSchema,
    responseIsArray: true,
    response: null as MultipostListingInquiryStats,
  }),
  createMultipostInquiryFromN8n: multipostInquiry.buildPost({
    path: '/create',
    payloadSchema: createMultipostInquiryPayloadSchema,
  }),
}
